import {store} from '@/store.js';

/**
 * The Learning API refused to send the accreditation again. `reason` is the camelCase name of
 * the RetryAccreditationOutcome ('alreadyAccepted', 'noUserRegistration', 'noApplicableMapping'),
 * or null when the response carried none (network error, 404, 500, ...).
 */
export class AccreditationRetryError extends Error {
    constructor(status, reason) {
        super(`Retry accreditation failed (${status}${reason ? `: ${reason}` : ''})`);
        this.name = 'AccreditationRetryError';
        this.status = status;
        this.reason = reason ?? null;
    }
}

/**
 * POST accreditations/catalogitem/{targetId}/retry: sends an accreditation that PE-online did not
 * accept again. Resolves with the updated accreditation (new result, previous result, data) -
 * also when PE-online refused it again, the status of the row tells.
 */
export const retryAccreditation = async ({targetId, id}) => {
    const {oidc, minervaSettings} = store.getState();
    const {apiUrl} = minervaSettings;
    const params = new URLSearchParams({accreditationId: id});

    const res = await fetch(
        `${apiUrl}/api/1.0/accreditations/catalogitem/${targetId}/retry?${params}`,
        {
            method: 'POST',
            headers: oidc.user ? {Authorization: `Bearer ${oidc.user.access_token}`} : {},
        },
    );

    if (!res.ok) {
        throw new AccreditationRetryError(res.status, await readReason(res));
    }

    return res.json();
};

const readReason = async (res) => {
    try {
        return (await res.json())?.reason ?? null;
    } catch {
        return null;
    }
};
